{
  "___TODO": "effacer cette partie des textes inutilisés",
  "title": "Créer un sous-compte",
  "next": "Suivant",
  "finish": "Terminer",
  "back": "Retour",
  "selectAccount": "Veuillez sélectionner un compte",
  "topics": {
    "selectAccount": "Sélectionner un compte",
    "createAccount": "Créer un compte",
    "createSubAccount": "Créer un sous-compte",
    "subAccountSummary": "Résumé du sous-compte"
  },
  "inherited": " - (hérité)",
  "subAccountSummary": {
    "added": "Vous avez correctement ajouté un nouveau sous-compte",
    "failed": "Échec de l'ajout d'un nouveau sous-compte.",
    "subAccMsg": "Relions cet objectif à un sous-compte",
    "subAccountSubTitle": "Vous avez correctement créé un sous-compte",
    "name": "Nom",
    "portfolioTheme": "Thème de portefeuille",
    "Portfolio": "Portefeuille",
    "requireIPS": "Demander un énoncé de politique d'investisseur",
    "allowClientDeposit": "Autoriser les dépôts par le client",
    "allowFractionalShare": "Autoriser le fractionnement d'action"
  },
  "theyHaveActiveAccounts_one": "Cette {{entity}} possède actuellement {{count}} compte actif.",
  "theyHaveActiveAccounts_other": "Cette {{entity}} possède actuellement {{count}} comptes actifs.",
  "client": "client",
  "household": "famille",
  "corporation": "entreprise",
  "useExistingOrCreateNew": "Souhaitez-vous utiliser un compte existant pour votre sous-compte ou en créer un nouveau?",
  "createAccountFirst": "Veuillez d'abord créer un nouveau compte.",
  "actions": {
    "useExsistingAccount": "Utiliser un compte existant",
    "createNewAccount": "Créer un nouveau compte",
    "createSubAccount": "Créer un sous-compte",
    "reviewDocuments": "Examiner les documents",
    "goToSubaccount": "Accéder au sous-compte",
    "almost": "C'est presque terminé…",
    "next": "Suivant"
  }
}
